import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountEventTypeListComponent } from './account-event-type-list.component';

import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';

@NgModule({
  declarations: [AccountEventTypeListComponent],
  imports: [CommonModule, FormsModule, TableModule, ButtonModule, RippleModule, InputTextModule, DropdownModule, TooltipModule],
  exports: [AccountEventTypeListComponent],
})
export class AccountEventTypeListModule {}
